<template>
  <div>
    <!-- 标题 -->
    <!-- <div>
        <van-nav-bar title="资讯详情" />
      </div> -->
    <!-- 内容 -->
    <div :class="type==2?'essays':'essay'">
      <div class="essayTitle" style="font-size: 18px;text-align: center;">{{ list.title }}</div>
      <div class="rikind" style="font-size: 14px;text-align: end;font-weight: 100;margin-top: 20px">{{ list.approveTime }}</div>
      <!-- <div class="rikind">{{ list.IssTime }}</div> -->
      <!-- <div v-if="list.ThematicUrl"
          class="essayImg">
          <img :src="list.ThematicUrl"
            alt=""
            @click="thematic(list.ThematicUrl)" />
        </div> -->
      <p
          class="essayContent"
          style="margin-top: 0"
          v-html="list.content"
          @click="imageEnlargement"
      ></p>
      <div class="video" v-if="list.Video">
        <video style="width: 100%" :src="list.Video" controls="controls">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div
          class="video"
          v-if="list.Annex"
          style="color: #1989fa; margin: 0 10px"
          @click="gotoUrl(list.Annex)"
      >
        <a
            :href="list.Annex"
            style="color: #1989fa"
            download="附件"
            class="video"
        >
          附件链接
        </a>
      </div>
<!--      <div class="rikinds" style="text-align: start"  v-show="list.isParty==1">报名时间：{{ list.signUpStart }} 至 {{ list.signUpEnd }}</div>-->

      <div class="rikinds" style="text-align: start;margin-bottom: 40px"  v-show="type==2">活动时间：{{ list.startTime }} 至 {{ list.endTime }}</div>
      <!-- <div class="rikind" style="text-align: right;">阅读：{{ list.ReadNum }}</div> -->
      <!--      <div class="rikind" style="text-align: right">{{ list.IssTime }}</div>-->


      <!-- <div id="demo"
          class="m-pdf"></div> -->

      <!-- <iframe style="width:100%;height:78vh;" :src="pdf"></iframe> -->
    </div>
<!--    <div class="privateLetter" v-show="list.isParty==1">-->
<!--      <div class="privateLetterB" @click="privateLetter()" style="  margin-right:0%;" v-if="list.status==2">未报名</div>-->
<!--      <div class="privateLetterBC" @click="privateLetter()" style="  margin-right:0%;" v-else-if="list.status==1">未开始</div>-->
<!--      <div class="privateLetterBC" style="  margin-right:0%;" v-if="list.status==3">已报名-({{list.partyRoleName}})</div>-->
<!--      <div class="privateLetterBC" style="  margin-right:0%;background-color: rgb(151, 151, 151);" v-if="list.status==4">报名已结束</div>-->
<!--      <div class="privateLetterBC" style="  margin-right:0%;" v-if="list.status==5">活动进行中</div>-->
<!--      <div class="privateLetterBC" style="  margin-right:0%;background-color: rgb(151, 151, 151);" v-if="list.status==6">活动已结束</div>-->
<!--    </div>-->

  </div>
</template>
<script>
import {ImagePreview, Toast} from "vant";
// import { WeWorkreportInfo, WePBEnrolActivity } from "@/api/RealInfo";
import {merchantActivity, merchantInformation, trealinfoDetails} from "@/api/Changan-zhsq/NewsArticles";
import { setOpenId, getOpenId } from "@/utils/auth";
import { Dialog } from "vant";
import Pdfh5 from "pdfh5";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      startData:1, //1:未开始  2:已结束  3：开始报名
      list: {},
      type:1,
      pdf: "",
      pdfh5: "",
    };
  },
  methods: {
    privateLetter(){
      let that = this;
      //显示弹窗
      if (window.__wxjs_environment === "miniprogram") {
        Toast.fail(this.$route.query.isLogin);
        //判断是否登录
        if(this.$route.query.isLogin==true){
          window.wx.miniProgram.navigateTo({
            url: "/pages/public/partPerson/index?roleArray=" + that.list.roleArray + '&RIId=' + that.list.RIId + '&isRegister=' + that.list.isRegister,
          });
        } else{
          Toast.fail("请先授权！正在跳转授权页面！");
          setTimeout(function () {
            window.wx.miniProgram.navigateTo({
              url: "/pages/home/login",
            });
          }, 1000)

        }

        // 页面 不会重新加载

        // }, 100);
      } else {
        alert("请在微信小程序中打开");
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }

    },
    gotoUrl(url) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/downLoading?url=" + url,
        });
        // }, 100);
      } else {
        alert("请在微信小程序中打开");
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    thematic(e) {
      ImagePreview({
        images: [e], // 传递的是图片集数组
        startPosition: 0, // 图片索引位置
        closeable: true, // 是否显示关了按钮
        showIndicators: true, // 是否显示轮播指示器
        loop: false, // 不设置为false,首图和尾部图不能正常加载
      });
    },
    // 富文本图片内容 点击放大
    imageEnlargement(e) {
      if (e.target.nodeName === "IMG") {
        ImagePreview({
          images: [e.target.src], // 传递的是图片集数组
          startPosition: 0, // 图片索引位置
          closeable: true, // 是否显示关了按钮
          showIndicators: true, // 是否显示轮播指示器
          loop: false, // 不设置为false,首图和尾部图不能正常加载
        });
      }
    },

    isCurrentTimeInRange(startTime, endTime) {
      // 获取当前时间
      const now = new Date();

      // 解析开始和结束时间
      const start = new Date(startTime.replace(' ', 'T') + 'Z');
      const end = new Date(endTime.replace(' ', 'T') + 'Z');

      // 判断当前时间是否在区间内
      return now >= start && now <= end;
    },
    isBeforeTargetTime(targetTime) {
      // 获取当前时间
      const now = new Date();

      // 处理输入参数（支持字符串或Date对象）
      const target = typeof targetTime === 'string'
          ? new Date(targetTime.replace(' ', 'T') + 'Z')
          : targetTime;

      // 比较时间
      return now < target;
    },
    // 获取资讯详情 https://api.qxzhqm.cn//upload/files/2022/3/20211217-老城区民营经济综合服务平台（PC端）(1)(1).docx
    getRealInfo() {
      let type=this.$route.params.type;
      this.type=this.$route.params.type;
      if (type==1) {
        merchantInformation(this.$route.params.Id).then((res) => {
          this.list = res.data.data;
          // let startBoolean=this.isBeforeTargetTime(res.data.data.signUpStart+" 00:00:00");
          // let booleam=this.isCurrentTimeInRange(res.data.data.signUpStart+" 00:00:00",res.data.data.signUpEnd+" 23:59:59");
          // //在区间内
          // if(booleam){
          //   this.startData=3
          // }else{
          //   if(startBoolean){
          //     this.startData=1
          //   }else{
          //     this.startData=2
          //   }
          // }
        });
      }else{
        merchantActivity(this.$route.params.Id).then((res) => {
          this.list = res.data.data;
          // let startBoolean=this.isBeforeTargetTime(res.data.data.signUpStart+" 00:00:00");
          // let booleam=this.isCurrentTimeInRange(res.data.data.signUpStart+" 00:00:00",res.data.data.signUpEnd+" 23:59:59");
          // //在区间内
          // if(booleam){
          //   this.startData=3
          // }else{
          //   if(startBoolean){
          //     this.startData=1
          //   }else{
          //     this.startData=2
          //   }
          // }
        });
      }

    },

    activated() {
      var _this = this;
      _this.uuid = _this.$route.query.uuid;
      var shareUrl = global.BASE_SHARE_URL + "grade?uuid=" + _this.uuid;
      this.$wxShare.updateWxShareConfig({
        title: "标题",
        desc: "简介",
        link: shareUrl,
      });
    },
  },
  mounted() {
    this.getRealInfo();
  },
};
</script>
<style scoped>

</style>
<style>
.essays{
  width: 95%;
  margin: 10px auto;
  padding-bottom: 25px;
  overflow: auto;
  max-height: calc(100vh-160px);
}
.essay {
  width: 95%;
  margin: 10px auto;
  padding-bottom: 25px;
  overflow: auto;
  max-height: calc(100vh);
}
.essays .essayContent img {
  display: inline;
  max-width: 100%;

}
.essay .essayContent img {
  display: inline;
  max-width: 100%;

}
.pageNum-num {
  display: none;
}
.m-pdf img {
  width: 100%;
}
.button {
  width: 95%;
  margin: 15px 2.5%;
}
/* table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}
th, td {
  border: 1px solid #ddd;
} */
.privateLetter{
  position: fixed;
  bottom: 5%;
  left: 10%;
  right: 20%;
  /* padding: 0px 10%; */
  width: 80%;
}
.privateLetterBC{
  width: 100%;
  height: 60px;
  background-color: #2e95ff;
  line-height: 60px;
  text-align: center;
  border-radius: 8px;
  float: left;
  margin-right:5%;
  color: #ffffff;
}
.privateLetterB{
  width: 100%;
  height: 60px;
  background-color:#0c9565 ;
  line-height: 60px;
  text-align: center;
  border-radius: 8px;
  float: left;
  margin-right:5%;
  color: #ffffff;
}
.rikinds{
  margin: 5px 15px;
  font-size: 14px;
  color: #020202;
}
</style>
